var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-guide-search"},[_c('user-guide-search-sidebar',{attrs:{"search-query":_vm.searchQuery,"search-results-counter":_vm.searchResultsCounter}}),_c('user-guide-search-results-list',{attrs:{"search-results":_vm.searchResults}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }